import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material'
import {
  AddressContext,
  AddressProviderValue,
} from 'pages/address/address.provider'
import { useContext } from 'react'
import { FilterType } from 'store/company/company.types'

const FactoredDirectToggle = () => {
  const { filterType, setFilterType } = useContext(
    AddressContext
  ) as AddressProviderValue

  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    value: FilterType | null
  ) => {
    if (value === 'factoring' || value === 'not_factoring') {
      setFilterType(value)
    }
  }

  return (
    <Box sx={{ px: 0, py: 1.5 }}>
      <ToggleButtonGroup
        exclusive
        fullWidth
        value={filterType}
        onChange={handleChange}
        sx={{
          bgcolor: 'grey.200',
          borderRadius: '24px',
          p: 0.5,
          '& .MuiToggleButtonGroup-grouped': {
            border: 0,
            borderRadius: '20px !important',
            mx: 0.25,
            py: 0.75,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.875rem',
            color: 'text.primary',
            '&.Mui-selected': {
              bgcolor: 'primary.main',
              color: 'common.white',
              '&:hover': {
                bgcolor: 'primary.dark',
              },
            },
          },
        }}
      >
        <ToggleButton value="factoring">Factored</ToggleButton>
        <ToggleButton value="not_factoring">Direct</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )
}

export default FactoredDirectToggle
